/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  MembershipActiveUpdate,
  OrganizationPurge,
  OrganizationPurgeResult,
  OrganizationRead,
  OrganizationUpdate,
  PaginatedOrganizationsResponse,
  PaginatedTutorialTagsResponse,
  PaginatedUserReportsResponse,
  PaginatedUsersResponse,
  SuperadminOrganizationCreate,
  TutorialTagCreate,
  TutorialTagUpdate,
  TutorialTagWithUsage,
  UserCreate,
  UserCreateResponse,
  UserRead,
  UserReportBulkStatusResult,
  UserReportBulkStatusUpdate,
  UserReportCategory,
  UserReportRead,
  UserReportSource,
  UserReportStatus,
  UserReportUpdate,
  UserUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    MembershipActiveUpdateFromJSON,
    MembershipActiveUpdateToJSON,
    OrganizationPurgeFromJSON,
    OrganizationPurgeToJSON,
    OrganizationPurgeResultFromJSON,
    OrganizationPurgeResultToJSON,
    OrganizationReadFromJSON,
    OrganizationReadToJSON,
    OrganizationUpdateFromJSON,
    OrganizationUpdateToJSON,
    PaginatedOrganizationsResponseFromJSON,
    PaginatedOrganizationsResponseToJSON,
    PaginatedTutorialTagsResponseFromJSON,
    PaginatedTutorialTagsResponseToJSON,
    PaginatedUserReportsResponseFromJSON,
    PaginatedUserReportsResponseToJSON,
    PaginatedUsersResponseFromJSON,
    PaginatedUsersResponseToJSON,
    SuperadminOrganizationCreateFromJSON,
    SuperadminOrganizationCreateToJSON,
    TutorialTagCreateFromJSON,
    TutorialTagCreateToJSON,
    TutorialTagUpdateFromJSON,
    TutorialTagUpdateToJSON,
    TutorialTagWithUsageFromJSON,
    TutorialTagWithUsageToJSON,
    UserCreateFromJSON,
    UserCreateToJSON,
    UserCreateResponseFromJSON,
    UserCreateResponseToJSON,
    UserReadFromJSON,
    UserReadToJSON,
    UserReportBulkStatusResultFromJSON,
    UserReportBulkStatusResultToJSON,
    UserReportBulkStatusUpdateFromJSON,
    UserReportBulkStatusUpdateToJSON,
    UserReportCategoryFromJSON,
    UserReportCategoryToJSON,
    UserReportReadFromJSON,
    UserReportReadToJSON,
    UserReportSourceFromJSON,
    UserReportSourceToJSON,
    UserReportStatusFromJSON,
    UserReportStatusToJSON,
    UserReportUpdateFromJSON,
    UserReportUpdateToJSON,
    UserUpdateFromJSON,
    UserUpdateToJSON,
} from '../models/index';

export interface ActivateUserRequest {
    userId: string;
}

export interface AddUserToOrganizationRequest {
    userId: string;
    organizationId: string;
    requestBody: Array<number>;
}

export interface BulkUpdateUserReportStatusRequest {
    userReportBulkStatusUpdate: UserReportBulkStatusUpdate;
}

export interface CreateTutorialTagRequest {
    tutorialTagCreate: TutorialTagCreate;
}

export interface DeactivateUserRequest {
    userId: string;
}

export interface DeleteTutorialTagRequest {
    tagId: string;
}

export interface DeleteUserReportRequest {
    reportId: string;
}

export interface GetTutorialTagRequest {
    tagId: string;
}

export interface GetUserRequest {
    userId: string;
}

export interface GetUserReportRequest {
    reportId: string;
}

export interface ListAllUsersRequest {
    skip?: number;
    limit?: number;
    search?: string | null;
    organizationId?: string | null;
    roleId?: number | null;
    isActive?: boolean | null;
    sortBy?: ListAllUsersSortByEnum;
    sortOrder?: ListAllUsersSortOrderEnum;
}

export interface ListUserReportsRequest {
    status?: UserReportStatus | null;
    category?: UserReportCategory | null;
    source?: UserReportSource | null;
    search?: string | null;
    skip?: number;
    limit?: number;
    sortBy?: ListUserReportsSortByEnum;
    sortOrder?: ListUserReportsSortOrderEnum;
}

export interface RemoveUserFromOrganizationRequest {
    userId: string;
    organizationId: string;
}

export interface SetMembershipActiveRequest {
    userId: string;
    organizationId: string;
    membershipActiveUpdate: MembershipActiveUpdate;
}

export interface SuperadminCreateOrganizationRequest {
    superadminOrganizationCreate: SuperadminOrganizationCreate;
}

export interface SuperadminCreateUserRequest {
    userCreate: UserCreate;
    organizationId?: string | null;
    roleIds?: Array<number> | null;
}

export interface SuperadminDeleteOrganizationRequest {
    organizationId: string;
}

export interface SuperadminDeleteUserRequest {
    userId: string;
}

export interface SuperadminGetOrganizationRequest {
    organizationId: string;
}

export interface SuperadminListAllOrganizationsRequest {
    skip?: number;
    limit?: number;
    search?: string | null;
    licenseStatus?: SuperadminListAllOrganizationsLicenseStatusEnum;
    isActive?: boolean | null;
}

export interface SuperadminListTutorialTagsRequest {
    skip?: number;
    limit?: number;
    search?: string | null;
}

export interface SuperadminPurgeOrganizationRequest {
    organizationId: string;
    organizationPurge: OrganizationPurge;
}

export interface SuperadminResetUserPasswordRequest {
    userId: string;
}

export interface SuperadminUpdateOrganizationRequest {
    organizationId: string;
    organizationUpdate: OrganizationUpdate;
}

export interface SuperadminUpdateUserRequest {
    userId: string;
    userUpdate: UserUpdate;
}

export interface UpdateTutorialTagRequest {
    tagId: string;
    tutorialTagUpdate: TutorialTagUpdate;
}

export interface UpdateUserReportRequest {
    reportId: string;
    userReportUpdate: UserReportUpdate;
}

export interface UpdateUserRolesInOrganizationRequest {
    userId: string;
    organizationId: string;
    requestBody: Array<number>;
}

/**
 * 
 */
export class SuperadminApi extends runtime.BaseAPI {

    /**
     * Activate a user account.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to activate     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 for one\'s own account (\"You cannot remove yourself from an organization or change your own membership or account status\")
     * Activate User
     */
    async activateUserRaw(requestParameters: ActivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling activateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}/activate`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Activate a user account.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to activate     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 for one\'s own account (\"You cannot remove yourself from an organization or change your own membership or account status\")
     * Activate User
     */
    async activateUser(requestParameters: ActivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.activateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a user to an organization with specific roles. A superadmin may add themselves.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     organization_id: ID of the organization     role_ids: List of role IDs to assign     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message with added roles  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin, or the superadmin role is requested     HTTPException: 400 if the role list is empty, the user is already in the organization, the seat limit is reached or a role ID is invalid     HTTPException: 404 if user or organization not found
     * Add User To Organization
     */
    async addUserToOrganizationRaw(requestParameters: AddUserToOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling addUserToOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling addUserToOrganization().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling addUserToOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}/organizations/{organization_id}/roles`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Add a user to an organization with specific roles. A superadmin may add themselves.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     organization_id: ID of the organization     role_ids: List of role IDs to assign     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message with added roles  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin, or the superadmin role is requested     HTTPException: 400 if the role list is empty, the user is already in the organization, the seat limit is reached or a role ID is invalid     HTTPException: 404 if user or organization not found
     * Add User To Organization
     */
    async addUserToOrganization(requestParameters: AddUserToOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.addUserToOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set one status on up to 200 reports and record the caller as handler; superadmins only.  Answers 404 and changes nothing when any id is unknown.
     * Bulk Update User Report Status
     */
    async bulkUpdateUserReportStatusRaw(requestParameters: BulkUpdateUserReportStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserReportBulkStatusResult>> {
        if (requestParameters['userReportBulkStatusUpdate'] == null) {
            throw new runtime.RequiredError(
                'userReportBulkStatusUpdate',
                'Required parameter "userReportBulkStatusUpdate" was null or undefined when calling bulkUpdateUserReportStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/user-reports/bulk-status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserReportBulkStatusUpdateToJSON(requestParameters['userReportBulkStatusUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReportBulkStatusResultFromJSON(jsonValue));
    }

    /**
     * Set one status on up to 200 reports and record the caller as handler; superadmins only.  Answers 404 and changes nothing when any id is unknown.
     * Bulk Update User Report Status
     */
    async bulkUpdateUserReportStatus(requestParameters: BulkUpdateUserReportStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserReportBulkStatusResult> {
        const response = await this.bulkUpdateUserReportStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new tutorial tag.  **Authorization:** Superadmins only.
     * Create Tutorial Tag
     */
    async createTutorialTagRaw(requestParameters: CreateTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TutorialTagWithUsage>> {
        if (requestParameters['tutorialTagCreate'] == null) {
            throw new runtime.RequiredError(
                'tutorialTagCreate',
                'Required parameter "tutorialTagCreate" was null or undefined when calling createTutorialTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/tutorial-tags/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TutorialTagCreateToJSON(requestParameters['tutorialTagCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TutorialTagWithUsageFromJSON(jsonValue));
    }

    /**
     * Create a new tutorial tag.  **Authorization:** Superadmins only.
     * Create Tutorial Tag
     */
    async createTutorialTag(requestParameters: CreateTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TutorialTagWithUsage> {
        const response = await this.createTutorialTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate a user account.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to deactivate     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 if trying to deactivate own account
     * Deactivate User
     */
    async deactivateUserRaw(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deactivateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}/deactivate`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deactivate a user account.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to deactivate     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 if trying to deactivate own account
     * Deactivate User
     */
    async deactivateUser(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.deactivateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a tutorial tag.  This will also remove the tag from all tutorials it was assigned to.  **Authorization:** Superadmins only.
     * Delete Tutorial Tag
     */
    async deleteTutorialTagRaw(requestParameters: DeleteTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling deleteTutorialTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/tutorial-tags/{tag_id}`.replace(`{${"tag_id"}}`, encodeURIComponent(String(requestParameters['tagId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a tutorial tag.  This will also remove the tag from all tutorials it was assigned to.  **Authorization:** Superadmins only.
     * Delete Tutorial Tag
     */
    async deleteTutorialTag(requestParameters: DeleteTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTutorialTagRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a report; superadmins only.
     * Delete User Report
     */
    async deleteUserReportRaw(requestParameters: DeleteUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling deleteUserReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/user-reports/{report_id}`.replace(`{${"report_id"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a report; superadmins only.
     * Delete User Report
     */
    async deleteUserReport(requestParameters: DeleteUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserReportRaw(requestParameters, initOverrides);
    }

    /**
     * Get a tutorial tag by ID.  **Authorization:** Superadmins only.
     * Get Tutorial Tag
     */
    async getTutorialTagRaw(requestParameters: GetTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TutorialTagWithUsage>> {
        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling getTutorialTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/tutorial-tags/{tag_id}`.replace(`{${"tag_id"}}`, encodeURIComponent(String(requestParameters['tagId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TutorialTagWithUsageFromJSON(jsonValue));
    }

    /**
     * Get a tutorial tag by ID.  **Authorization:** Superadmins only.
     * Get Tutorial Tag
     */
    async getTutorialTag(requestParameters: GetTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TutorialTagWithUsage> {
        const response = await this.getTutorialTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a specific user.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to retrieve     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     User details including all organizations and roles  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found
     * Get User
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRead>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
    }

    /**
     * Get detailed information about a specific user.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to retrieve     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     User details including all organizations and roles  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found
     * Get User
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRead> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read one report; superadmins only.
     * Get User Report
     */
    async getUserReportRaw(requestParameters: GetUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserReportRead>> {
        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling getUserReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/user-reports/{report_id}`.replace(`{${"report_id"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReportReadFromJSON(jsonValue));
    }

    /**
     * Read one report; superadmins only.
     * Get User Report
     */
    async getUserReport(requestParameters: GetUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserReportRead> {
        const response = await this.getUserReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List users with optional filtering, sorted and paginated.  **Authorization:** Superadmins only.  Args:     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     skip: Number of records to skip for pagination     limit: Maximum number of records to return     search: Optional search string for username/email     organization_id: Optional filter by organization     role_id: Optional filter by role     is_active: Optional filter by active status     sort_by: username (default), created_at or last_login (never logged in sorts last)     sort_order: asc (default) or desc  Returns:     The page of users with the total matching the filters  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin
     * List All Users
     */
    async listAllUsersRaw(requestParameters: ListAllUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedUsersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['roleId'] != null) {
            queryParameters['role_id'] = requestParameters['roleId'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sort_order'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedUsersResponseFromJSON(jsonValue));
    }

    /**
     * List users with optional filtering, sorted and paginated.  **Authorization:** Superadmins only.  Args:     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     skip: Number of records to skip for pagination     limit: Maximum number of records to return     search: Optional search string for username/email     organization_id: Optional filter by organization     role_id: Optional filter by role     is_active: Optional filter by active status     sort_by: username (default), created_at or last_login (never logged in sorts last)     sort_order: asc (default) or desc  Returns:     The page of users with the total matching the filters  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin
     * List All Users
     */
    async listAllUsers(requestParameters: ListAllUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedUsersResponse> {
        const response = await this.listAllUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List reports filtered by status, category, source and a search text, sorted and paginated; superadmins only.
     * List User Reports
     */
    async listUserReportsRaw(requestParameters: ListUserReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedUserReportsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sort_order'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/user-reports/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedUserReportsResponseFromJSON(jsonValue));
    }

    /**
     * List reports filtered by status, category, source and a search text, sorted and paginated; superadmins only.
     * List User Reports
     */
    async listUserReports(requestParameters: ListUserReportsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedUserReportsResponse> {
        const response = await this.listUserReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a user from an organization (removes all their roles in that org).  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     organization_id: ID of the organization     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user or organization not found     HTTPException: 400 if user is organization owner or holds the superadmin role in it     HTTPException: 400 for one\'s own account (\"You cannot remove yourself from an organization or change your own membership or account status\")
     * Remove User From Organization
     */
    async removeUserFromOrganizationRaw(requestParameters: RemoveUserFromOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling removeUserFromOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling removeUserFromOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}/organizations/{organization_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Remove a user from an organization (removes all their roles in that org).  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     organization_id: ID of the organization     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user or organization not found     HTTPException: 400 if user is organization owner or holds the superadmin role in it     HTTPException: 400 for one\'s own account (\"You cannot remove yourself from an organization or change your own membership or account status\")
     * Remove User From Organization
     */
    async removeUserFromOrganization(requestParameters: RemoveUserFromOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.removeUserFromOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate or reactivate a user\'s membership in one organization.  Sets the user\'s role rows in the organization active or inactive, except superadmin rows. The account, its sessions and other organizations stay. Reactivating works for the organization\'s owner too (for example an owner whose rows were all deactivated).  **Authorization:** Superadmins only.  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user or organization not found, or the user is not a member     HTTPException: 400 when deactivating the owner, or the user\'s only rows there are superadmin rows     HTTPException: 400 for one\'s own account, either value (\"You cannot remove yourself from an organization or change your own membership or account status\")
     * Set Membership Active
     */
    async setMembershipActiveRaw(requestParameters: SetMembershipActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling setMembershipActive().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling setMembershipActive().'
            );
        }

        if (requestParameters['membershipActiveUpdate'] == null) {
            throw new runtime.RequiredError(
                'membershipActiveUpdate',
                'Required parameter "membershipActiveUpdate" was null or undefined when calling setMembershipActive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}/organizations/{organization_id}/active`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipActiveUpdateToJSON(requestParameters['membershipActiveUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deactivate or reactivate a user\'s membership in one organization.  Sets the user\'s role rows in the organization active or inactive, except superadmin rows. The account, its sessions and other organizations stay. Reactivating works for the organization\'s owner too (for example an owner whose rows were all deactivated).  **Authorization:** Superadmins only.  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user or organization not found, or the user is not a member     HTTPException: 400 when deactivating the owner, or the user\'s only rows there are superadmin rows     HTTPException: 400 for one\'s own account, either value (\"You cannot remove yourself from an organization or change your own membership or account status\")
     * Set Membership Active
     */
    async setMembershipActive(requestParameters: SetMembershipActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.setMembershipActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an active organization for a named owner, with or without a license.  `owner_id` must name an existing, active account (the superadmin may name themselves); the owner gets an active administrator role in the new organization. `license_key` is optional: when given it must name an active, unexpired license that no other organization uses; omitted or empty, the organization starts without a license (free tier) until one is attached. The name is stripped and must be at least three characters long.  **Authorization:** Superadmins only.  Args:     organization_data: Name, owner and optional license key     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     The created organization  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If the owner or the license key is not found     HTTPException 400: If the name exists, the owner\'s account is deactivated, or the         license is inactive, expired or used by another organization (also when taken         concurrently)     HTTPException 422: If the name is missing or too short, or `owner_id` is missing
     * Superadmin Create Organization
     */
    async superadminCreateOrganizationRaw(requestParameters: SuperadminCreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationRead>> {
        if (requestParameters['superadminOrganizationCreate'] == null) {
            throw new runtime.RequiredError(
                'superadminOrganizationCreate',
                'Required parameter "superadminOrganizationCreate" was null or undefined when calling superadminCreateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/organizations/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SuperadminOrganizationCreateToJSON(requestParameters['superadminOrganizationCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationReadFromJSON(jsonValue));
    }

    /**
     * Create an active organization for a named owner, with or without a license.  `owner_id` must name an existing, active account (the superadmin may name themselves); the owner gets an active administrator role in the new organization. `license_key` is optional: when given it must name an active, unexpired license that no other organization uses; omitted or empty, the organization starts without a license (free tier) until one is attached. The name is stripped and must be at least three characters long.  **Authorization:** Superadmins only.  Args:     organization_data: Name, owner and optional license key     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     The created organization  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If the owner or the license key is not found     HTTPException 400: If the name exists, the owner\'s account is deactivated, or the         license is inactive, expired or used by another organization (also when taken         concurrently)     HTTPException 422: If the name is missing or too short, or `owner_id` is missing
     * Superadmin Create Organization
     */
    async superadminCreateOrganization(requestParameters: SuperadminCreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationRead> {
        const response = await this.superadminCreateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new user and optionally add them to an organization with roles.  **Authorization:** Superadmins only.  Args:     user_data: User creation data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     organization_id: Optional organization to add user to     role_ids: Optional list of role IDs to assign in the organization  Returns:     Created user details; `generated_password` is set when no password was given  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 400 if username/email already exists     HTTPException: 400 if organization_id provided but role_ids not provided
     * Superadmin Create User
     */
    async superadminCreateUserRaw(requestParameters: SuperadminCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserCreateResponse>> {
        if (requestParameters['userCreate'] == null) {
            throw new runtime.RequiredError(
                'userCreate',
                'Required parameter "userCreate" was null or undefined when calling superadminCreateUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['roleIds'] != null) {
            queryParameters['role_ids'] = requestParameters['roleIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateToJSON(requestParameters['userCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create a new user and optionally add them to an organization with roles.  **Authorization:** Superadmins only.  Args:     user_data: User creation data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     organization_id: Optional organization to add user to     role_ids: Optional list of role IDs to assign in the organization  Returns:     Created user details; `generated_password` is set when no password was given  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 400 if username/email already exists     HTTPException: 400 if organization_id provided but role_ids not provided
     * Superadmin Create User
     */
    async superadminCreateUser(requestParameters: SuperadminCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserCreateResponse> {
        const response = await this.superadminCreateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an organization that holds no school data, together with its memberships.  Users are never deleted. An organization with workshops, classes, event participations, competitors or tutorial assignments is refused, and so is one that carries a SUPERADMIN role row (the API cannot restore it); deactivate it instead (`PUT` with `is_active: false`).  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to delete     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If organization not found     HTTPException 409: If the organization has content or a superadmin role row.         `detail` is `{\"message\": str, \"counts\": {\"workshops\": n, \"classes\": n,         \"events\": n, \"competitors\": n, \"tutorial_assignments\": n, \"superadmins\": n}}`
     * Superadmin Delete Organization
     */
    async superadminDeleteOrganizationRaw(requestParameters: SuperadminDeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling superadminDeleteOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/organizations/{organization_id}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an organization that holds no school data, together with its memberships.  Users are never deleted. An organization with workshops, classes, event participations, competitors or tutorial assignments is refused, and so is one that carries a SUPERADMIN role row (the API cannot restore it); deactivate it instead (`PUT` with `is_active: false`).  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to delete     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If organization not found     HTTPException 409: If the organization has content or a superadmin role row.         `detail` is `{\"message\": str, \"counts\": {\"workshops\": n, \"classes\": n,         \"events\": n, \"competitors\": n, \"tutorial_assignments\": n, \"superadmins\": n}}`
     * Superadmin Delete Organization
     */
    async superadminDeleteOrganization(requestParameters: SuperadminDeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.superadminDeleteOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a user together with their sessions (tokens), organization memberships and class memberships, in one transaction.  A user who owns or authored content (organizations, problems, competitions, events, workshops, classes, tutorials, added competitors), has a learning history (competition teams, saved code, submissions, workshop attendance) or holds a SUPERADMIN role is refused with 409 and `detail: {message, counts}`; deactivate such a user instead.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to delete     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     204 No Content on success  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 if trying to delete own account     HTTPException: 409 if content or a superadmin role blocks the delete
     * Superadmin Delete User
     */
    async superadminDeleteUserRaw(requestParameters: SuperadminDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling superadminDeleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a user together with their sessions (tokens), organization memberships and class memberships, in one transaction.  A user who owns or authored content (organizations, problems, competitions, events, workshops, classes, tutorials, added competitors), has a learning history (competition teams, saved code, submissions, workshop attendance) or holds a SUPERADMIN role is refused with 409 and `detail: {message, counts}`; deactivate such a user instead.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to delete     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     204 No Content on success  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 if trying to delete own account     HTTPException: 409 if content or a superadmin role blocks the delete
     * Superadmin Delete User
     */
    async superadminDeleteUser(requestParameters: SuperadminDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.superadminDeleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Get a specific organization by ID.  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to retrieve     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Organization details  Raises:     HTTPException 404: If organization not found
     * Superadmin Get Organization
     */
    async superadminGetOrganizationRaw(requestParameters: SuperadminGetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationRead>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling superadminGetOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/organizations/{organization_id}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationReadFromJSON(jsonValue));
    }

    /**
     * Get a specific organization by ID.  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to retrieve     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Organization details  Raises:     HTTPException 404: If organization not found
     * Superadmin Get Organization
     */
    async superadminGetOrganization(requestParameters: SuperadminGetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationRead> {
        const response = await this.superadminGetOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List organizations by name, with owner, license details and member count.  **Authorization:** Superadmins only.  Args:     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     skip: Number of records to skip for pagination     limit: Maximum number of records to return     search: Optional search term to filter by organization name     license_status: Optional license status filter     is_active: Optional active flag filter  Returns:     The page of organizations with the total matching the filters  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin
     * Superadmin List All Organizations
     */
    async superadminListAllOrganizationsRaw(requestParameters: SuperadminListAllOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedOrganizationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['licenseStatus'] != null) {
            queryParameters['license_status'] = requestParameters['licenseStatus'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/organizations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedOrganizationsResponseFromJSON(jsonValue));
    }

    /**
     * List organizations by name, with owner, license details and member count.  **Authorization:** Superadmins only.  Args:     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     skip: Number of records to skip for pagination     limit: Maximum number of records to return     search: Optional search term to filter by organization name     license_status: Optional license status filter     is_active: Optional active flag filter  Returns:     The page of organizations with the total matching the filters  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin
     * Superadmin List All Organizations
     */
    async superadminListAllOrganizations(requestParameters: SuperadminListAllOrganizationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedOrganizationsResponse> {
        const response = await this.superadminListAllOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List tutorial tags ordered by name, each with the number of live (not deleted) tutorials it is assigned to.  **Authorization:** Superadmins only.
     * Superadmin List Tutorial Tags
     */
    async superadminListTutorialTagsRaw(requestParameters: SuperadminListTutorialTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTutorialTagsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/tutorial-tags/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTutorialTagsResponseFromJSON(jsonValue));
    }

    /**
     * List tutorial tags ordered by name, each with the number of live (not deleted) tutorials it is assigned to.  **Authorization:** Superadmins only.
     * Superadmin List Tutorial Tags
     */
    async superadminListTutorialTags(requestParameters: SuperadminListTutorialTagsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTutorialTagsResponse> {
        const response = await this.superadminListTutorialTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permanently delete a deactivated organization together with its school data.  Deletes its teams with their members and submissions, its event participations, workshops (participants and problem links), classes (member rows), tutorial assignments and every role row in it, then the organization, in one transaction. User accounts, problems, competitions, events and tutorials stay; its teams\' results disappear from the events it took part in. `name` must be the organization\'s exact name (surrounding spaces ignored). For an organization without school data, `DELETE` does the same without deactivation.  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to purge     data: The organization\'s name, typed to confirm     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     The number of deleted rows per kind of data  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If organization not found     HTTPException 400: If `name` is not the organization\'s name     HTTPException 409: If the organization is active (\"Deactivate the organization before         purging it\"); if it holds a SUPERADMIN role row (`detail` as         `{\"message\": str, \"counts\": {...}}` like `DELETE`); or if data referencing it         appeared during the purge (\"Content changed during the purge; try again\")
     * Superadmin Purge Organization
     */
    async superadminPurgeOrganizationRaw(requestParameters: SuperadminPurgeOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationPurgeResult>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling superadminPurgeOrganization().'
            );
        }

        if (requestParameters['organizationPurge'] == null) {
            throw new runtime.RequiredError(
                'organizationPurge',
                'Required parameter "organizationPurge" was null or undefined when calling superadminPurgeOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/organizations/{organization_id}/purge`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationPurgeToJSON(requestParameters['organizationPurge']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationPurgeResultFromJSON(jsonValue));
    }

    /**
     * Permanently delete a deactivated organization together with its school data.  Deletes its teams with their members and submissions, its event participations, workshops (participants and problem links), classes (member rows), tutorial assignments and every role row in it, then the organization, in one transaction. User accounts, problems, competitions, events and tutorials stay; its teams\' results disappear from the events it took part in. `name` must be the organization\'s exact name (surrounding spaces ignored). For an organization without school data, `DELETE` does the same without deactivation.  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to purge     data: The organization\'s name, typed to confirm     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     The number of deleted rows per kind of data  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If organization not found     HTTPException 400: If `name` is not the organization\'s name     HTTPException 409: If the organization is active (\"Deactivate the organization before         purging it\"); if it holds a SUPERADMIN role row (`detail` as         `{\"message\": str, \"counts\": {...}}` like `DELETE`); or if data referencing it         appeared during the purge (\"Content changed during the purge; try again\")
     * Superadmin Purge Organization
     */
    async superadminPurgeOrganization(requestParameters: SuperadminPurgeOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationPurgeResult> {
        const response = await this.superadminPurgeOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset a user\'s password to a randomly generated one.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     New temporary password  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 for one\'s own account (\"Use /auth/change-password to change your own password\")
     * Superadmin Reset User Password
     */
    async superadminResetUserPasswordRaw(requestParameters: SuperadminResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling superadminResetUserPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}/reset-password`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Reset a user\'s password to a randomly generated one.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     New temporary password  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 for one\'s own account (\"Use /auth/change-password to change your own password\")
     * Superadmin Reset User Password
     */
    async superadminResetUserPassword(requestParameters: SuperadminResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.superadminResetUserPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an organization\'s name, owner, license or active flag.  `license_key`: null keeps the license, an empty string detaches it, any other value must name an active, unexpired license that no other organization uses. `is_active`: false deactivates the organization (members lose access, data, memberships and license stay), true reactivates it. `owner_id`: a new owner must be an active account and a member of the organization with an active administrator role there. Omit a field to keep it; an explicit null for `name`, `is_active` or `owner_id` answers 422.  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to update     organization_data: Updated organization data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Updated organization  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If organization, owner or license key not found     HTTPException 400: If the new name exists, or the license is inactive, expired or         used by another organization (also when taken concurrently), or the new owner\'s         account is deactivated or the owner is not a member holding an active         administrator role there     HTTPException 422: If `name`, `is_active` or `owner_id` is sent as null
     * Superadmin Update Organization
     */
    async superadminUpdateOrganizationRaw(requestParameters: SuperadminUpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationRead>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling superadminUpdateOrganization().'
            );
        }

        if (requestParameters['organizationUpdate'] == null) {
            throw new runtime.RequiredError(
                'organizationUpdate',
                'Required parameter "organizationUpdate" was null or undefined when calling superadminUpdateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/organizations/{organization_id}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUpdateToJSON(requestParameters['organizationUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationReadFromJSON(jsonValue));
    }

    /**
     * Update an organization\'s name, owner, license or active flag.  `license_key`: null keeps the license, an empty string detaches it, any other value must name an active, unexpired license that no other organization uses. `is_active`: false deactivates the organization (members lose access, data, memberships and license stay), true reactivates it. `owner_id`: a new owner must be an active account and a member of the organization with an active administrator role there. Omit a field to keep it; an explicit null for `name`, `is_active` or `owner_id` answers 422.  **Authorization:** Superadmins only.  Args:     organization_id: UUID of the organization to update     organization_data: Updated organization data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Updated organization  Raises:     HTTPException 401: If user not authenticated     HTTPException 403: If user is not a superadmin     HTTPException 404: If organization, owner or license key not found     HTTPException 400: If the new name exists, or the license is inactive, expired or         used by another organization (also when taken concurrently), or the new owner\'s         account is deactivated or the owner is not a member holding an active         administrator role there     HTTPException 422: If `name`, `is_active` or `owner_id` is sent as null
     * Superadmin Update Organization
     */
    async superadminUpdateOrganization(requestParameters: SuperadminUpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationRead> {
        const response = await this.superadminUpdateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update any user\'s information.  On one\'s own account only the profile fields (`username`, `email`, `phone`, `first_name`, `last_name`, `grade`) may be sent, as on `PUT /users/{own id}`. Roles are not changed here: they are set per organization through `/superadmin/users/{id}/organizations/{org}/roles`, so a `role_ids` for another user answers 400. A refused request changes nothing.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to update     user_data: Updated user data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Updated user details  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 if username/email already taken by another user; for one\'s own         account: `is_active: false` (\"Cannot deactivate your own account\"), a `password`         (\"Use /auth/change-password to change your own password\"), `role_ids` or         `is_active: true` (\"Only profile fields can be changed on your own account\"); for         another user: `role_ids` (\"Roles are set per organization: use         /superadmin/users/{id}/organizations/{organization_id}/roles\")
     * Superadmin Update User
     */
    async superadminUpdateUserRaw(requestParameters: SuperadminUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRead>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling superadminUpdateUser().'
            );
        }

        if (requestParameters['userUpdate'] == null) {
            throw new runtime.RequiredError(
                'userUpdate',
                'Required parameter "userUpdate" was null or undefined when calling superadminUpdateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateToJSON(requestParameters['userUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
    }

    /**
     * Update any user\'s information.  On one\'s own account only the profile fields (`username`, `email`, `phone`, `first_name`, `last_name`, `grade`) may be sent, as on `PUT /users/{own id}`. Roles are not changed here: they are set per organization through `/superadmin/users/{id}/organizations/{org}/roles`, so a `role_ids` for another user answers 400. A refused request changes nothing.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user to update     user_data: Updated user data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Updated user details  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if user not found     HTTPException: 400 if username/email already taken by another user; for one\'s own         account: `is_active: false` (\"Cannot deactivate your own account\"), a `password`         (\"Use /auth/change-password to change your own password\"), `role_ids` or         `is_active: true` (\"Only profile fields can be changed on your own account\"); for         another user: `role_ids` (\"Roles are set per organization: use         /superadmin/users/{id}/organizations/{organization_id}/roles\")
     * Superadmin Update User
     */
    async superadminUpdateUser(requestParameters: SuperadminUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRead> {
        const response = await this.superadminUpdateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a tutorial tag.  **Authorization:** Superadmins only.
     * Update Tutorial Tag
     */
    async updateTutorialTagRaw(requestParameters: UpdateTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TutorialTagWithUsage>> {
        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling updateTutorialTag().'
            );
        }

        if (requestParameters['tutorialTagUpdate'] == null) {
            throw new runtime.RequiredError(
                'tutorialTagUpdate',
                'Required parameter "tutorialTagUpdate" was null or undefined when calling updateTutorialTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/tutorial-tags/{tag_id}`.replace(`{${"tag_id"}}`, encodeURIComponent(String(requestParameters['tagId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TutorialTagUpdateToJSON(requestParameters['tutorialTagUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TutorialTagWithUsageFromJSON(jsonValue));
    }

    /**
     * Update a tutorial tag.  **Authorization:** Superadmins only.
     * Update Tutorial Tag
     */
    async updateTutorialTag(requestParameters: UpdateTutorialTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TutorialTagWithUsage> {
        const response = await this.updateTutorialTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the status or admin note and record the caller as the handler; superadmins only.
     * Update User Report
     */
    async updateUserReportRaw(requestParameters: UpdateUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserReportRead>> {
        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling updateUserReport().'
            );
        }

        if (requestParameters['userReportUpdate'] == null) {
            throw new runtime.RequiredError(
                'userReportUpdate',
                'Required parameter "userReportUpdate" was null or undefined when calling updateUserReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/user-reports/{report_id}`.replace(`{${"report_id"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserReportUpdateToJSON(requestParameters['userReportUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReportReadFromJSON(jsonValue));
    }

    /**
     * Update the status or admin note and record the caller as the handler; superadmins only.
     * Update User Report
     */
    async updateUserReport(requestParameters: UpdateUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserReportRead> {
        const response = await this.updateUserReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a user\'s roles in a specific organization.  This replaces all existing roles with the provided ones. The user must already be a member of the organization, and the organization owner must keep the administrator role. A superadmin row the user has in this organization is kept. A superadmin may change their own roles here.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     organization_id: ID of the organization     role_ids: New list of role IDs to assign     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message with updated roles  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin, or the superadmin role is requested     HTTPException: 404 if user or organization not found, or the user is not a member     HTTPException: 400 if the role list is empty, a role ID is invalid or the owner would lose the administrator role
     * Update User Roles In Organization
     */
    async updateUserRolesInOrganizationRaw(requestParameters: UpdateUserRolesInOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateUserRolesInOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateUserRolesInOrganization().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateUserRolesInOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superadmin/users/{user_id}/organizations/{organization_id}/roles`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update a user\'s roles in a specific organization.  This replaces all existing roles with the provided ones. The user must already be a member of the organization, and the organization owner must keep the administrator role. A superadmin row the user has in this organization is kept. A superadmin may change their own roles here.  **Authorization:** Superadmins only.  Args:     user_id: ID of the user     organization_id: ID of the organization     role_ids: New list of role IDs to assign     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message with updated roles  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin, or the superadmin role is requested     HTTPException: 404 if user or organization not found, or the user is not a member     HTTPException: 400 if the role list is empty, a role ID is invalid or the owner would lose the administrator role
     * Update User Roles In Organization
     */
    async updateUserRolesInOrganization(requestParameters: UpdateUserRolesInOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateUserRolesInOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListAllUsersSortByEnum = {
    Username: 'username',
    CreatedAt: 'created_at',
    LastLogin: 'last_login'
} as const;
export type ListAllUsersSortByEnum = typeof ListAllUsersSortByEnum[keyof typeof ListAllUsersSortByEnum];
/**
 * @export
 */
export const ListAllUsersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListAllUsersSortOrderEnum = typeof ListAllUsersSortOrderEnum[keyof typeof ListAllUsersSortOrderEnum];
/**
 * @export
 */
export const ListUserReportsSortByEnum = {
    CreatedAt: 'created_at',
    Status: 'status'
} as const;
export type ListUserReportsSortByEnum = typeof ListUserReportsSortByEnum[keyof typeof ListUserReportsSortByEnum];
/**
 * @export
 */
export const ListUserReportsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListUserReportsSortOrderEnum = typeof ListUserReportsSortOrderEnum[keyof typeof ListUserReportsSortOrderEnum];
/**
 * @export
 */
export const SuperadminListAllOrganizationsLicenseStatusEnum = {
    Active: 'active',
    Expiring: 'expiring',
    Expired: 'expired',
    None: 'none'
} as const;
export type SuperadminListAllOrganizationsLicenseStatusEnum = typeof SuperadminListAllOrganizationsLicenseStatusEnum[keyof typeof SuperadminListAllOrganizationsLicenseStatusEnum];
